// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FootTrafficSkeletonComponent } from './components/foot-traffic-skeleton/foot-traffic-skeleton.component';
import { IconTooltipModule } from '@coa/app/shared/icon-tooltip/icon-tooltip.module';
import { SpyLineChartModule } from '@coa/app/shared/spy-line-chart/spy-line-chart.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChartDataSeriesModule } from '@coa/app/shared/chart-data-series/chart-data-series.module';
import { MatRippleModule } from '@angular/material/core';
import { ScaleTicksPipeModule } from '@coa/app/shared/chart-js/scale-ticks-pipe/scale-ticks-pipe.module';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';

@NgModule({
  declarations: [
    FootTrafficSkeletonComponent,
  ],
  imports: [
    CommonModule,
    IconTooltipModule,
    SpyLineChartModule,
    TranslateModule,
    ChartDataSeriesModule,
    MatRippleModule,
    ScaleTicksPipeModule,
    FeatureToggleModule,
  ],
  exports: [
    FootTrafficSkeletonComponent,
  ],
})
export class FootTrafficModule {
}
